var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contract-list" }, [
    _c(
      "ul",
      { staticClass: "list" },
      [
        _vm._l(_vm.list, function (item) {
          return _c("li", { key: item.id, staticClass: "item" }, [
            _c("div", { staticClass: "header" }, [
              _vm._v(
                "\n        状态：" +
                  _vm._s(_vm._f("statusText")(item.status)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "body" }, [
              _c("span", { staticClass: "block" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("合同编号：")]),
                _vm._v(_vm._s(item.col_2)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("房屋地址：")]),
                _vm._v(_vm._s(item.col_3) + "-" + _vm._s(item.col_4)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("起租日期：")]),
                _vm._v(_vm._s(item.col_245)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("终止日期：")]),
                _vm._v(_vm._s(item.col_84)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("租金总额：")]),
                _vm._v(_vm._s(item.col_25)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("承办人：")]),
                _vm._v(_vm._s(item.col_42)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "inline" }, [
                _c("span", { staticClass: "lable" }, [_vm._v("发起时间：")]),
                _vm._v(_vm._s(item.add_time)),
              ]),
              _vm._v(" "),
              item.htid
                ? _c("span", { staticClass: "block" }, [
                    _c("span", { staticClass: "lable" }, [
                      _vm._v("上上签合同编号："),
                    ]),
                    _vm._v(_vm._s(item.htid)),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "footer" }, [
              item.status == "01"
                ? _c(
                    "div",
                    {
                      staticClass: "btn wran",
                      on: {
                        click: function ($event) {
                          return _vm.cancleContract(item)
                        },
                      },
                    },
                    [_vm._v("撤销")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.status == "00"
                ? _c(
                    "div",
                    {
                      staticClass: "btn wran",
                      on: {
                        click: function ($event) {
                          return _vm.unlockContract(item)
                        },
                      },
                    },
                    [_vm._v("解锁")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn wran",
                  on: {
                    click: function ($event) {
                      return _vm.picContract(item)
                    },
                  },
                },
                [_vm._v("附件")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn normal",
                  on: {
                    click: function ($event) {
                      return _vm.goToPreviewContract(item)
                    },
                  },
                },
                [_vm._v("预览")]
              ),
              _vm._v(" "),
              item.status == "00"
                ? _c(
                    "div",
                    {
                      staticClass: "btn wran",
                      on: {
                        click: function ($event) {
                          return _vm.goToEditContract(item)
                        },
                      },
                    },
                    [_vm._v("修改")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.status == "01"
                ? _c(
                    "div",
                    {
                      staticClass: "btn wran",
                      on: {
                        click: function ($event) {
                          return _vm.goPerfectContract(item)
                        },
                      },
                    },
                    [_vm._v("补充")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.status == "00"
                ? _c(
                    "div",
                    {
                      staticClass: "btn primary",
                      on: {
                        click: function ($event) {
                          return _vm.publishContract(item)
                        },
                      },
                    },
                    [_vm._v("发布")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.status == "01"
                ? _c(
                    "div",
                    {
                      staticClass: "btn primary",
                      on: {
                        click: function ($event) {
                          return _vm.searchContract(item)
                        },
                      },
                    },
                    [_vm._v("进度")]
                  )
                : _vm._e(),
              _vm._v(" "),
              ["01", "10", "30"].includes(item.status)
                ? _c(
                    "div",
                    {
                      staticClass: "btn primary",
                      on: {
                        click: function ($event) {
                          return _vm.repainContract(item)
                        },
                      },
                    },
                    [_vm._v("重签")]
                  )
                : _vm._e(),
              _vm._v(" "),
              item.htid
                ? _c(
                    "div",
                    {
                      staticClass: "btn primary",
                      on: {
                        click: function ($event) {
                          return _vm.gotoSSQContract(item)
                        },
                      },
                    },
                    [_vm._v("查看合同")]
                  )
                : _vm._e(),
            ]),
          ])
        }),
        _vm._v(" "),
        _vm.hasMore
          ? _c("li", { staticClass: "next", on: { click: _vm.nextPage } }, [
              _vm._v("下一页"),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.list.length == 0
      ? _c("div", { staticClass: "list-null" }, [_vm._v(" 暂无数据 ")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }